// extracted by mini-css-extract-plugin
module.exports = {"spinner":"styles_spinner__25TZT","centered":"styles_centered__Gp9SW"};